import { render, staticRenderFns } from "./bottomFooter.vue?vue&type=template&id=89025218&scoped=true"
import script from "./bottomFooter.vue?vue&type=script&lang=js"
export * from "./bottomFooter.vue?vue&type=script&lang=js"
import style0 from "./bottomFooter.vue?vue&type=style&index=0&id=89025218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89025218",
  null
  
)

export default component.exports